import '@mdi/font/css/materialdesignicons.css';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles';

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#2E7D32',
    secondary: '#F6F6F7',
    error: '#e11717',
    info: '#2196F3',
    success: '#2E7D32',
    warning: '#FB8C00'
  }
};

const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    background: '#242424',
    surface: '#242424',
    primary: '#66bb69',
    secondary: '#2e2e2e',
    error: '#e11717',
    info: '#2196F3',
    success: '#66bb69',
    warning: '#FB8C00'
  }
};

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi'
  },
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      darkTheme,
      lightTheme
    }
  }
});
